import React from "react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@core/components/ui/tooltip";
import { TooltipContentProps } from "@radix-ui/react-tooltip";

interface TooltipWrapperProps extends React.PropsWithChildren<object>, TooltipContentProps {
  tooltipContent: React.ReactNode | string;
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ children, tooltipContent, ...props }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent {...props}>
          {tooltipContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};